import AceEditor from 'react-ace';
import 'ace-builds/src-min-noconflict/ext-language_tools';
import 'ace-builds/src-min-noconflict/mode-mysql';
import 'ace-builds/src-min-noconflict/theme-tomorrow';
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { CompleterCallback, Editor, EditSession, Point } from 'ace-builds';

type KeywordCompleterList={ [key: string]: unknown; }[];

class KeywordCompleter {
  keywordExtension: string[] = [];
  isSpliceValue = false;
  cloneDeepDataSource: KeywordCompleterList = [];
  identifierRegexps?: Array<RegExp> = [];
  constructor(keywords: string[], flag: boolean, list: KeywordCompleterList) {
    this.keywordExtension = keywords;
    this.isSpliceValue = flag;
    this.cloneDeepDataSource = list;
  };
  // 获取热词
  getCompletions(
    editor: Editor,
    session: EditSession,
    position: Point,
    prefix: string,
    callback: CompleterCallback,
  ): void {
 
    // 使用外部传入的数据源
    const dataSource =this.isSpliceValue ? this.cloneDeepDataSource:  this.keywordExtension?.map((word: string) => ({
      caption: word,
      value: word,
      meta: 'column',
    }));; 
    callback(
      null,
      dataSource
    );
  }
  // 用于重新改造keywordExtension数组里的所有元素
  //  updateKeywordExtension(callback: (word: string) => string): void {
  //   this.keywordExtension = this.keywordExtension.map((word: string) => callback(word));
  // }
}

const LazyEditorInner = (props: any, ref: any) => {
  const aceEditor = useRef();
  const { keywordExtension, isSpliceValue = false, replaceKeywordExtension }: { keywordExtension: string[]; isSpliceValue?: boolean; replaceKeywordExtension?: KeywordCompleterList; } = props;
  useImperativeHandle(ref, () => ({
    moveCursor: (row: number, column: number) => {
      aceEditor.current?.editor?.gotoLine(row + 1, column, false);
    },
  }));
  // 自定义AutoComplete输入提示
  useEffect(() => {
    const completer = new KeywordCompleter(keywordExtension, isSpliceValue, replaceKeywordExtension);
    const all = aceEditor.current?.editor?.completers || [];
    let find = false;
    if (all.length > 0) {
      for (let i = 0;i < all.length;i++) {
        if (all[i] instanceof KeywordCompleter) {
          all[i] = completer;
          find = true;
        }
      }
    }
    if (find === false) {
      aceEditor.current?.editor?.completers?.push(completer);
    }
  }, [JSON.stringify(keywordExtension), isSpliceValue, replaceKeywordExtension]);

  // 自定义highlight高亮语法
  useEffect(() => {
    const editor = aceEditor.current?.editor;
    const rules = editor.session.$mode.$highlightRules.getRules();
    for (const stateName in rules) {
      if (Object.prototype.hasOwnProperty.call(rules, stateName)) {
        rules[stateName].unshift({
          token: 'error_highlight',
          regex: 'tX|请设置',
        });
      }
    }
    // force recreation of tokenizer
    editor.session.$mode.$tokenizer = null;
    editor.session.bgTokenizer.setTokenizer(editor.session.$mode.getTokenizer());
    // force re-highlight whole document
    editor.session.bgTokenizer.start(0);
  }, []);

  return <AceEditor ref={aceEditor} {...props} />;
};

export const LazyEditor = forwardRef(LazyEditorInner);
